// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".check-all[data-v-016c536e]{display:flex;width:100%;position:sticky;top:0;padding:.4rem;z-index:1;background:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
